// react
import { useState } from "react";
// axios
import axios from "../../../axios/axios";
// components
import Ripple from "../../UI/spinners/ripple/Ripple";
import OTPBox from "../OTPBox/OTPBox";

const LoginForm = () => {
  const [formData, setFormData] = useState({
    username: "",
    otp: "",
    error: null,
  });
  const [otpInputShown, setotpInputShown] = useState(false);

  // handle input change
  const inputChangedHandler = (event) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: event.target.value,
    }));
  };

  // focus input handler
  const inputFocusHandler = (event) => {
    event.target.readOnly = false;
  };

  // handle login
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);

  const loginUserHandler = (event) => {
    event.preventDefault();
    setSubmitButtonDisabled(true);
    axios({
      method: "POST",
      url: "/mechanic/requestOTPForMechanic",
      data: { username: formData.username },
    })
      .then((res) => res.data)
      .then(() => {
        setFormData((prevFormData) => ({ ...prevFormData, error: "" }));
        setSubmitButtonDisabled(false);
        setotpInputShown(true);
      })
      .catch((err) => {
        setSubmitButtonDisabled(false);
        if (err?.response.status === 401) {
          setFormData((prevData) => ({
            ...prevData,
            error: "اسم المستخدم غير موجود",
          }));
        }
      });
  };

  let submitButton;
  if (otpInputShown) {
    submitButton = (
      <OTPBox username={formData.username} setFormData={setFormData} />
    );
  } else {
    submitButton = (
      <button
        onClick={loginUserHandler}
        disabled={submitButtonDisabled}
        className="w-full flex justify-center items-center bg-dark-blue text-white text-center text-2xl p-4 rounded-lg disabled:text-slate-800 disabled:bg-slate-200 disabled:cursor-not-allowed"
      >
        {submitButtonDisabled ? (
          <Ripple className="border-dark-blue" />
        ) : (
          "تسجيل الدخول"
        )}
      </button>
    );
  }

  return (
    <form method="POST" className="space-y-4 w-full" autoComplete="off">
      {!otpInputShown && (
        <div>
          <label htmlFor="username" className="block font-semibold text-2xl">
            رقم الهاتف
          </label>
          <input
            id="username"
            className="p-2 border border-#DFDFDF rounded w-full text-right text-2xl numeric-content"
            type="tel"
            value={formData.username}
            placeholder="01xxxxxxxxx"
            readOnly
            name="username"
            onChange={inputChangedHandler}
            onFocus={inputFocusHandler}
            disabled={otpInputShown}
          />
        </div>
      )}

      {submitButton}

      {formData.error && (
        <p className="text-center uppercase text-red-600 font-semibold text-xl">
          {formData.error}
        </p>
      )}
    </form>
  );
};

export default LoginForm;
